module.exports = __webpack_public_path__ + "img/php.d11a17c0.png";